import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from 'app/core/service/core/Global';

@Injectable({ providedIn: 'root' })
export class SessionApiService {
  private http = inject(HttpClient);
  private base = `${Global.url}V1/sessions`;

  defaults() { return this.http.get<any>(`${this.base}/defaults`); }
  list() { return this.http.get<any[]>(this.base); }
  create(body: { voteMode: string; linkBpm: boolean; placeName?: string; periodId: number }) {
    return this.http.post<any>(this.base, body);
  }
  get(uuid: string) { return this.http.get<any>(`${this.base}/${uuid}`); }
  join(token: string) { return this.http.get<any>(`${this.base}/join/${token}`); }
  markPresent(uuid: string, userId: number) {
    return this.http.post<any>(`${this.base}/${uuid}/attendance`, { userId });
  }
  focus(uuid: string, itemId: number) {
    return this.http.post<any>(`${this.base}/${uuid}/focus`, { itemId });
  }
  openVote(uuid: string, itemId: number) {
    return this.http.post<any>(`${this.base}/${uuid}/open-vote`, { itemId });
  }
  vote(uuid: string, itemId: number, decision: 'APROBAR' | 'NO') {
    return this.http.post<any>(`${this.base}/${uuid}/vote`, { itemId, decision });
  }
  paperVote(uuid: string, itemId: number, userId: number, decision: 'APROBAR' | 'NO') {
    return this.http.post<any>(`${this.base}/${uuid}/paper-vote`, { itemId, userId, decision });
  }
  amounts(uuid: string, itemId: number, approvedDeductible: number, approvedAmount: number) {
    return this.http.post<any>(`${this.base}/${uuid}/amounts`, { itemId, approvedDeductible, approvedAmount });
  }
  closeItem(uuid: string, itemId: number, body: { outcome?: string; action?: string }) {
    return this.http.post<any>(`${this.base}/${uuid}/close-item`, { itemId, ...body });
  }
  close(uuid: string) { return this.http.post<any>(`${this.base}/${uuid}/close`, {}); }
}
